<template>
    <Page title="设备管理">
        <Card>
            <div class="total-line">
                <div class="total-block">
                    <div class="title-line">
                        <span class="sk-title-small">未绑定数量</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ noBind }}</span>
                    </div>
                </div>
                <div class="split-line"></div>
                <div class="total-block">
                    <div class="title-line">
                        <span class="sk-title-small">在线数量</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ onLine }}</span>
                    </div>
                </div>
                <div class="split-line"></div>
                <div class="total-block">
                    <div class="title-line">
                        <span class="sk-title-small">离线数量</span>
                    </div>
                    <div class="number-line">
                        <span class="sk-number-total">{{ offLine }}</span>
                    </div>
                </div>
            </div>
        </Card>
        <Card style="margin-top: 10px">
            <div class="condition-line">
                <Container rightWidth="200px">
                    <div class="block">
                        <el-input size="mini" v-model="searchParam.Key"></el-input>
                    </div>
                    <div class="block">
                        <el-button type="primary" size="mini" @click="searchData"> 查询 </el-button>
                    </div>
                    <div class="block" style="float: right">
                        <el-button type="primary" size="mini" icon="el-icon-upload" v-if="false">导入</el-button>
                        <el-button type="primary" size="mini" icon="el-icon-plus" @click="showAdd">新增</el-button>
                    </div>
                </Container>
            </div>
            <div class="content-line-padding">
                <el-table size="mini" :data="dataList">
                    <el-table-column type="index" width="80px" label="序号"></el-table-column>
                    <el-table-column prop="DeviceID" label="设备编号">
                        <template #default="{ row }">
                            <Guid :text="row.DeviceID"></Guid>
                        </template>
                    </el-table-column>
                    <el-table-column prop="DeviceSN" label="设备序列号"></el-table-column>
                    <el-table-column prop="DeviceName" label="设备名称"></el-table-column>
                    <el-table-column prop="DeviceModel" label="设备型号"></el-table-column>
                    <el-table-column prop="DoorName" label="所在通道"></el-table-column>
                    <el-table-column prop="EntityName" label="实体"></el-table-column>
                    <el-table-column prop="DeviceType" label="状态">
                        <template #default="{ row }">{{ row.State ? "在线" : "离线" }}</template>
                    </el-table-column>
                    <el-table-column prop="LastDatetime" label="最后上报时间"></el-table-column>
                    <el-table-column label="操作">
                        <template #default="{ row }">
                            <el-button type="danger" @click="removeRow(row)" size="mini" icon="el-icon-delete">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </Card>
        <DeviceEdit v-if="visible" v-model:visible="visible" @refresh="getData"></DeviceEdit>
    </Page>
</template>
<script>
import DeviceEdit from "./components/DeviceEdit";
export default {
    name: "Role",
    components: {
        DeviceEdit,
    },
    data() {
        return {
            searchParam: {
                Key: "",
            },
            searchUrl: "/Entity/GetDeviceStates",
            visible: false,
            pageIndex: 1,
            pageSize: 20,
            count: 0,
            dataList: [],
            noBind: 0,
            offLine: 4,
            onLine: 0,
        };
    },
    methods: {
        getData() {
            this.searchData();
        },
        showAdd() {
            this.visible = true;
            this.$forceUpdate();
        },
        removeRow(row) {
            this.$myConfirm().then(() => {
                this.$ajax.post("/Entity/RemoveDevice?id=" + row.DeviceID).then((res) => {
                    this.$success("操作成功");
                    this.getData();
                });
            });
        },
        searchData() {
            let p = Object.assign({}, this.searchParam);
            this.$ajax.post(this.searchUrl, p).then((result) => {
                this.dataList = result.Data.ListData;
                this.noBind = result.Data.NoBind;
                this.offLine = result.Data.OffLine;
                this.onLine = result.Data.OnLine;
            });
        },
    },
    created() {
        this.getData();
    },
};
</script>
<style scoped>
.total-block {
    height: 50px;
}
.total-line .split-line {
    height: 50px;
}
</style>
